/**
 * The Orphion mark — a four-pointed compass star.
 *
 * A sharp, elongated 4-point star (compass / cardinal points) rendered as a
 * single filled polygon in the brand's accent tone. Reads as: distinct
 * directions locking into one centred rhythm.
 */
export const OrphionMark = ({ size = 24, className = "" }) => (
  <svg
    viewBox="0 0 32 32"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
  >
    <polygon
      points="16,2 18.5,13.5 30,16 18.5,18.5 16,30 13.5,18.5 2,16 13.5,13.5"
      fill="currentColor"
    />
  </svg>
);

export default OrphionMark;
